import "core-js";
import Form from "./src/Form";
import extendPhone from "./custom_rules/phone";
import extendIban from "./custom_rules/iban";
import extendCountryIban from "./custom_rules/countryiban";
import extendSSNFr from "./custom_rules/securiteSocialeFr";
import i18n from "./src/i18n";
import extendUnique from "./custom_rules/unique";
import extendPostalCode from "./custom_rules/postalcode";
import VeeValidate, { Validator } from "vee-validate";
import { version } from "./package.json";
import "./src/fingerprint";
import Dayjs from "vue-dayjs";

console.log("PROMO.DEV FORM BUILDER", version);

import fr from "vee-validate/dist/locale/fr";
import es from "vee-validate/dist/locale/es";
import en from "vee-validate/dist/locale/en";
import de from "vee-validate/dist/locale/de";
import nl from "vee-validate/dist/locale/nl";
import pl from "vee-validate/dist/locale/pl";
import sl from "vee-validate/dist/locale/sl";
import bg from "vee-validate/dist/locale/bg";
import ro from "vee-validate/dist/locale/ro";
import el from "vee-validate/dist/locale/el";
import pt from "vee-validate/dist/locale/pt_PT";

fr.custom = i18n.fr.VeeValidate.custom;
fr.attributes = i18n.fr.VeeValidate.attributes;
en.custom = i18n.uk.VeeValidate.custom;
en.attributes = i18n.uk.VeeValidate.attributes;
es.custom = i18n.es.VeeValidate.custom;
es.attributes = i18n.es.VeeValidate.attributes;
de.custom = i18n.de.VeeValidate.custom;
de.attributes = i18n.de.VeeValidate.attributes;
nl.custom = i18n.nl.VeeValidate.custom;
nl.attributes = i18n.nl.VeeValidate.attributes;
pl.custom = i18n.pl.VeeValidate.custom;
pl.attributes = i18n.pl.VeeValidate.attributes;
sl.custom = i18n.sl.VeeValidate.custom;
sl.attributes = i18n.sl.VeeValidate.attributes;
bg.custom = i18n.bg.VeeValidate.custom;
bg.attributes = i18n.bg.VeeValidate.attributes;
ro.custom = i18n.ro.VeeValidate.custom;
ro.attributes = i18n.ro.VeeValidate.attributes;
el.custom = i18n.el.VeeValidate.custom;
el.attributes = i18n.el.VeeValidate.attributes;
pt.custom = i18n.pt.VeeValidate.custom;
pt.attributes = i18n.pt.VeeValidate.attributes;

export default {
  Form,
  install(Vue) {
    Vue.use(Dayjs);
    Vue.use(VeeValidate);
    Vue.component("Form", Form);
    Validator.localize({ fr, es, de, nl, pl, sl, ro, el, pt });
    Validator.localize("fr");

    extendPhone(Validator);
    extendIban(Validator);
    extendCountryIban(Validator);
    extendSSNFr(Validator);
    extendUnique(Validator);
    extendPostalCode(Validator);
  },
};
